import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import {
  ApiService,
  AppointmentModel,
  EventRecord,
  IEventActor,
  Intake,
  IntakeModel,
  IntakeService,
  Patient,
} from '@mmx/shared'
import { filter, find, map, orderBy } from 'lodash'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

interface TimeLine {
  actor: IEventActor
  created: number
  stage: string
}

@Component({
  selector: 'mmx-timeline',
  templateUrl: './timeline.component.html',
  standalone: false,
})
export class TimelineComponent implements OnInit, OnDestroy {
  @Input() appointment: AppointmentModel
  @Input() patient: Patient

  logs: EventRecord[]
  timelines: any[]
  expandTimeLine = false
  intake: IntakeModel
  refreshInProgress = false

  private onDestroy$: Subject<void> = new Subject<void>()

  constructor(
    private intakeService: IntakeService,
    private restService: ApiService,
  ) {}

  ngOnInit(): void {
    this.getHistory()

    this.intakeService.onIntakeChange
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((intake) => {
        if (this.intake && intake && this.intake.stage !== intake.stage) {
          // Stage changed, we have to refresh
          this.getHistory()
        } else {
          this.intake = intake
        }
      })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }

  getActorName(actor: IEventActor): string | void {
    if (actor.type === 'clinician') {
      if (this.intakeService.clinicians) {
        const clinician = this.intakeService.clinicians.find(
          (c) => c.id === actor.id,
        )
        if (clinician) {
          return clinician.name
        }
      }
    } else if (actor.type === 'patient') {
      return this.patient.fullName
    } else if (actor.type === 'patientpal') {
      return 'From Integration'
    }

    return 'Unknow'
  }

  getIntakeStatusText(stage: string, type: string) {
    switch (stage) {
      case Intake.STAGE.SUBMITTED:
        if (type === 'patient') {
          return 'common.submitted'
        } else {
          //
          return 'Unsigned off'
        }
        break
      case Intake.STAGE.CONFIRMED:
        return 'common.confirmed'
      case Intake.STAGE.TECH_CONFIRMED:
        return 'common.signed-off-tech'
      case Intake.STAGE.TECH_REVIEW:
        return 'common.in-review'
      case Intake.STAGE.SYNCING:
        return 'common.syncing'
      case Intake.STAGE.SYNCED:
        return 'common.synced'
      case Intake.STAGE.DELIVERED:
        return 'common.delivered'
      default:
        return 'common.unspecified'
    }
  }

  private getHistory() {
    this.refreshInProgress = true

    this.restService.getPatientHistory(this.patient.id).subscribe((logs) => {
      this.timelines = orderBy(
        map(
          filter(logs, (log) => {
            // Filter by appointment and changes in stage attribute
            if (
              log.changes &&
              log.changes.length > 0 &&
              find(log.changes, (change) => change.attribute === 'stage') &&
              log.actor &&
              ((log.tableName === 'appointment' &&
                log.recordId === this.appointment.id) ||
                (log.data &&
                  log.data.appointmentId &&
                  log.data.appointmentId === this.appointment.id) ||
                (log.tableName === 'intake' && log.recordId === this.intake.id))
            ) {
              return true
            }
          }),
          (l) => {
            // Format to TimeLine
            const stage = l.changes.find((c) => c.attribute === 'stage')
            const timeline: TimeLine = {
              actor: l.actor,
              created: l.created,
              stage: stage.updated,
            }
            return timeline
          },
        ),
        'created',
      )
      this.refreshInProgress = false
    })
  }
}
